"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AthleteDto = /** @class */ (function () {
    function AthleteDto() {
    }
    return AthleteDto;
}());
exports.default = AthleteDto;
